module.exports = __webpack_public_path__ + "img/iphone-7.ff36c00d.png";